import { useEffect, useState } from 'react';

/**
 * Whether the browser currently has a network connection.
 *
 * A generation can run for minutes; without this, losing the network looks
 * identical to the model thinking, and the user waits for something that will
 * never arrive.
 */
export function useOnlineStatus(): boolean {
  const [online, setOnline] = useState(() => (
    typeof navigator === 'undefined' || navigator.onLine !== false
  ));

  useEffect(() => {
    const goOnline = () => setOnline(true);
    const goOffline = () => setOnline(false);
    window.addEventListener('online', goOnline);
    window.addEventListener('offline', goOffline);
    return () => {
      window.removeEventListener('online', goOnline);
      window.removeEventListener('offline', goOffline);
    };
  }, []);

  return online;
}
